  'use strict';

  angular.module('app.pages.dashboard')
    .factory('reportdata', reportdata);

  function reportdata($http, $q, esriLoader, appConfig) { // esriRegistry, $rootScope
    let fields = [];

    let service = {
      setFields: setFields,
      getPreAuctionData: getPreAuctionData,
      getPostAuctionData: getPostAuctionData,
      getUnsoldParcelsData: getUnsoldParcelsData,
      getDomainValues: getDomainValues,
      getRevalueData: getRevalueData,
      getClassRecsData: getClassRecsData,
      getFinalSaleData: getFinalSaleData,
      getForfeitValueChange: getForfeitValueChange,
      getDates: getDates,
      getTractListData: getTractListData
    };

    return service;

    function setFields(fieldValues) {
      fields = fieldValues;
    }

    // return the list of short-cut names and map extents
    function getPreAuctionData(params, polyLayer) {
      // console.log('params', params);
      let d = $q.defer();
      // _getAuctionedTracts(params)
      //   .then(function(results) {
          _getPreAuctionTracts(params)
            .then(function(results) {
              d.resolve(_processPreAuctionResults(results));
            });
  //      });
      return d.promise;

    }

    function getPostAuctionData(params, polyLayer) {
      let d = $q.defer();
      let tracts = [];
      // _getTractSales(params).then(function(results) {
      //   tracts = results;
      // });

      _getAuctionedTracts(params, polyLayer)
        .then(function(results) {
             let historyTracts = results;
            // console.log(saleTableResults);
            _getUnsoldTracts(params)
               .then(function(results) {
                 let unsoldTracts = results;
                // get YTD parcel sales
                _getYTDdata(params)
                  .then(function(results) {
                    // console.log('YTD results', results);
                    let salesYTD = results;
                    //    console.log('historyTracts', historyTracts);
                    // d.resolve(_processPostAuctionResults(saleTableResults, historyTracts, salesYTD));
                    d.resolve(_processPostAuctionResults(historyTracts, salesYTD, unsoldTracts));

                  });
              });

        });

      return d.promise;
    }

    function getClassRecsData(params) {
      let d = $q.defer();
      _getForfeitedParcels(params).then(function(results) {
        if (results.length > 0) {
          //  _getParcelInfoForClassRecs(results).then(function(results) {
          d.resolve(results);
          //  });
        } else {
          d.resolve([]);
        }
      });
      return d.promise;
    }

    function getTractListData(userQuery) {
      let d = $q.defer();
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        Query,
        QueryTask
      ) {
        // console.log('made it to the reportdata ', polyLayer);
        let queryTask = new QueryTask(appConfig.getConfig().tractsUrl);
        let query = new Query();
        query.where = userQuery;
        query.returnGeometry = false;
        // console.log('query.where', query.where);
        query.outFields = ['*'];
        queryTask.execute(query, function(results) {
          let features = results.features;
          // console.log('features', features);
          d.resolve(features);
        }, function(error) {
          console.error('Query error: ', error);
        });
      });
      return d.promise;
    }

    function getDates() {
      let d = $q.defer();
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        Query,
        QueryTask
      ) {
        // find distinct auction dates
        let query = new Query();
        query.returnGeometry = false;
        query.outFields = ['Last_LS_date'];
        query.returnDistinctValues = true;
        query.where = 'Last_LS_date IS NOT null';
        let queryTask = new QueryTask(appConfig.getConfig().parcelsUrl);
        queryTask.execute(query, function(results) {
          let features = results.features;
          let auctionYears = [];
          for (let feature in features) {
            let auctionDate = _formatEsriDate(features[feature].attributes.Last_LS_date); // jshint ignore:line
            if (auctionYears.indexOf(auctionDate.getFullYear()) < 0) {
              auctionYears.push(auctionDate.getFullYear());
            }
            auctionYears.push(auctionDate);
          }
          auctionYears.sort(function(a, b) {
            return b - a;
          });
          console.log('auctionYears', auctionYears);
          d.resolve(auctionYears);
        }, function(error) {
          console.error('Query error: ', error);
        });

      });
      return d.promise;
    }

    function _getForfeitedParcels(params) {
      let startDate = params.startDate;
      let endDate = params.endDate;
      // let taxForfeitStatus = params.forfeitStatus;
      // This is a hack to fix the undefined tax forfeit status
      // TODO: CWCT-695 This should be revised to not be a hack
      let taxForfeitStatus = 'Active';
      if (params.forfeitStatus != null) {
        taxForfeitStatus = params.forfeitStatus;
      }
      let d = $q.defer();
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        Query,
        QueryTask
      ) {
        // console.log('made it to the reportdata ', polyLayer);
        let queryTask = new QueryTask(appConfig.getConfig().parcelsUrl);
        let query = new Query();
        query.where = 'Forfeiture_date >= date \'' + startDate + '\' AND Forfeiture_date <= date \'' + endDate + '\' AND TaxForfeitedStatus = \'' + taxForfeitStatus + '\'' ;
        query.returnGeometry = false;
        console.log('query.where', query.where);
        query.outFields = ['PIN', 'Political_Sub', 'Office_Classification', 'Forfeiture_date', 'Sec', 'Twp', 'Rnge', 'Legals', 'PlatDesc', 'Block', 'Lot'];
        queryTask.execute(query, function(results) {
          let features = results.features;
          // console.log('features', features);
          let outParcels = [];
          for (let i = 0; i < features.length; i++) {
            if (features[i].attributes.Political_Sub != null) {
              outParcels.push(features[i]);
            }
          }
          d.resolve(outParcels);
        }, function(error) {
          console.error('Query error: ', error);
        });
      });
      return d.promise;
    }

    // This function is no longer necessary, since this data is now captured when the forfeitures CSV is uploaded

    // function _getParcelInfoForClassRecs(results) {
    //   console.log('_getParcelInfoForClassRecs');
    //   let d = $q.defer();
    //   esriLoader.require([
    //     'esri/tasks/query',
    //     'esri/tasks/QueryTask',
    //     'esri/config',
    //     'esri/request'
    //   ], function(
    //     Query,
    //     QueryTask,
    //     esriConfig,
    //     esriRequest
    //   ) {
    //     esriConfig.defaults.io.corsEnabledServers.push('gis.crowwing.us');
    //     let parcels = results;
    //     let pinNums = [];
    //     for (let id in parcels) {
    //       pinNums.push('\'' + parcels[id].attributes.PIN + '\'');
    //     }
    //     let queryTaxParcels = new Query();
    //     queryTaxParcels.outFields = ['APPRCL', 'APTOWN', 'APRANG', 'APSECT', 'PLDESC', 'LOTNBR', 'BLOCKNBR', 'LEGAL'];
    //     queryTaxParcels.where = 'APPRCL IN (' + pinNums.join(',') + ')';
    //     let requestHandle = esriRequest({
    //       'url': 'https://gis.crowwing.us/cwcexternal/rest/services/CROWWINGPUBLIC/MapServer/0/query',
    //       'content': {
    //         'f': 'json',
    //         'where': queryTaxParcels.where,
    //         'returnGeometry': false,
    //         'outFields': queryTaxParcels.outFields
    //       },
    //       'handeAs': 'json',
    //       'usePost': true,
    //       'callbackParamName': 'callback'
    //     }, {
    //       usePost: true
    //     });
    //     requestHandle.then(function(results) {
    //       let taxparcels = results.features;
    //       // console.log('results', taxparcels);
    //
    //       for (let i = 0; i < parcels.length; i++) {
    //         parcels[i] = parcels[i].attributes;
    //         for (let j = 0; j < taxparcels.length; j++) {
    //           if (parcels[i].PIN === taxparcels[j].attributes.APPRCL) {
    //             parcels[i].twnshp = taxparcels[j].attributes.APTOWN;
    //             parcels[i].sectn = taxparcels[j].attributes.APSECT;
    //             parcels[i].range = taxparcels[j].attributes.APRANG;
    //             parcels[i].platname = taxparcels[j].attributes.PLDESC;
    //             parcels[i].lotnum = taxparcels[j].attributes.LOTNBR;
    //             parcels[i].block = taxparcels[j].attributes.BLOCKNBR;
    //             parcels[i].legal = taxparcels[j].attributes.LEGAL;
    //           }
    //         }
    //         //  console.log(parcels[i]);
    //       }
    //       d.resolve(parcels);
    //     }, function(results) {
    //       d.resolve('error');
    //       console.log('error', results);
    //     });
    //   });
    //   return d.promise;
    // }

    function getRevalueData(params) {
      let d = $q.defer();
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        Query,
        QueryTask
      ) {
        // console.log('made it to the reportdata ', polyLayer);
        let queryTask = new QueryTask(appConfig.getConfig().parcelsUrl);
        let query = new Query();
        query.where = params.query;
        // console.log('userQuery: ', params.query);
        // query.where = 'Sold_type IS NULL AND Board_Class_Action = \'Non-Conservation\' AND TaxForfeitedStatus = \'Active\' AND Total_parcel_price IS NOT NULL';
        query.returnGeometry = false;
        query.outFields = ['PIN', 'Political_Sub', 'Last_LS_date', 'ReducedLandPrice', 'LandPriceIncrease', 'SpecAssessIncrease', 'SpecAssessDecrease'];
        queryTask.execute(query, function(results) {
          let features = results.features;
          // console.log('features', features);
          d.resolve(_processRevalueResults(features, {dateRange: params.dateRange, startDate: params.startDate, endDate: params.endDate}));
        }, function(error) {
          console.error('Query error: ', error);
        });
      });
      return d.promise;
    }

    function getFinalSaleData() {
      let d = $q.defer();
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        Query,
        QueryTask
      ) {
        // console.log('made it to the reportdata ', polyLayer);
        // console.log('tracts url: ', appConfig.getConfig().tractsUrl);
        let queryTask = new QueryTask(appConfig.getConfig().tractsUrl);
        // let queryTask = new QueryTask(appConfig.getConfig().parcelsUrl);
        let query = new Query();
        // let today = new Date();
        //broad query for testing
        // query.where = 'ProposedSaleType = \'Auction\' AND Tract IS NOT NULL';
        // query.where = '(CityTwpResponse = \'Approve\' OR CityTwpResponse = \'Approve by No Response\') AND DNRResponse = \'Approve\' AND ProposedSaleType = \'Auction\'';
        query.where = 'ProposedSaleType = \'Auction\'';
        query.returnGeometry = false;
        query.outFields = ['*'];
        queryTask.execute(query, function(results) {
          let tracts = results.features;
          d.resolve(_processFinalSaleListResults(tracts));
        }, function(error) {
          console.error('Query error: ', error);
        });
      });
      return d.promise;
    }

    function getForfeitValueChange(year) {
      console.log('getForfeitValueChange');
      let d = $q.defer();
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        Query,
        QueryTask
      ) {
        let queryTask = new QueryTask(appConfig.getConfig().parcelsUrl);
        let query = new Query();
        let today = new Date();
        //broad query for testing
        query.where = 'Board_Class_Action = \'Non-Conservation\' AND TaxForfeitedStatus = \'Active\' AND ProposedSaleType = \'Over the Counter\'';
        query.returnGeometry = false;
        query.outFields = ['PIN', 'Political_Sub', 'Twp', 'Sec', 'Rnge', 'Tract', 'Legacy_PIN'];
        queryTask.execute(query, function(results) {
            let lots = results.features;
            let parms = {
              'id': [],
              'newYear': year.toString(),
              'oldYear': (year - 1).toString()
            };
            parms.lots = _processForfeitValueChangeResults(lots);
            // console.log('lots: ', parms.lots);
            queryPropsAll(parms).then(function(response) {
              d.resolve(response);
            });

          },
          function(error) {
            console.error('Query error: ', error);
          });
      });
      return d.promise;
    }

    function queryPropsAll(params) {
      params.id = params.lots.map(function(elem) {
        return elem.legacyPin;
      });
      return $http.post('/api/v1/curpropvalues', {
          params: params
        })
        .then(function(response) {
          // console.log('response: ', response);
          response.data[0].forEach(function(item) {
            let selected = params.lots.filter(function(lot) {
              return lot.legacyPin === item.PARCELNBR;
            })[0];
            // console.log('item', item, 'selected', selected);
            item['physCity'] = selected.physCity;
            item['twp'] = selected.twp;
            item['section'] = selected.section;
            item['range'] = selected.range;
            item['tract'] = selected.tract;
          });

          return response.data[0];
        })
        .catch(function(error) {
          console.error(error);
        });
    }

    function getUnsoldParcelsData(params, polyLayer) {
      let d = $q.defer();
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        Query,
        QueryTask
      ) {
        // console.log('made it to the reportdata ', polyLayer);
        let queryTask = new QueryTask(appConfig.getConfig().parcelsUrl);
        let query = new Query();
        query.where = 'Sold_type IS NULL AND Board_Class_Action = \'Non-Conservation\' AND TaxForfeitedStatus = \'Active\' AND Total_parcel_price IS NOT NULL AND ProposedSaleType = \'Over the Counter\'';
        query.returnGeometry = false;
        query.outFields = ['*'];
        queryTask.execute(query, function(results) {
          let features = results.features;
          d.resolve(_processUnsoldParcelsResults(features));
        }, function(error) {
          console.error('Query error: ', error);
        });
      });

      return d.promise;
    }

    function _processPreAuctionResults(features) {
      // console.log('TRACTS', features);
      let politicalSubs = [];
      let politicalSubsDomain = getDomainValues('Political_Sub');
      for (let i = 0; i < features.length; i++) {
        // let dateConv = new Date(features[i].attributes.Last_LS_date);
        // features[i].attributes.Last_LS_date = dateConv.toLocaleString();
        // console.log(features[i].attributes.Last_LS_date);
        let featurePolSub = _.find(politicalSubsDomain, {
          'code': features[i].attributes.Political_Sub
        });
        let thePolSub = _.find(politicalSubs, {
          'polSubName': featurePolSub.name
        });
        // console.log('The pol sub: ', thePolSub);
        if (thePolSub == null) {
          let polSubReport = {
            'polSubName': featurePolSub.name,
            'tractCount': 1,
            'totalTractValue': features[i].attributes.Land_price + features[i].attributes.Imp_price
          };
          politicalSubs.push(polSubReport);
        }
        
        // DEBUG else/if please comment out when done
        // TODO: comment out the below item after debugging
        else if (featurePolSub.name === 'MISSION TOWNSHIP'){
          // console.log('Found Mission');
          // console.log( i + ' Found some land values', features[i].attributes.Land_price + features[i].attributes.Imp_price);
          thePolSub.tractCount++;
          thePolSub.totalTractValue += features[i].attributes.Land_price + features[i].attributes.Imp_price;
          
        } 
        
        else {
          thePolSub.tractCount++;
          thePolSub.totalTractValue += features[i].attributes.Land_price + features[i].attributes.Imp_price;
        }
      }
      console.warn('PoliticalSubs (cities)', politicalSubs);
      return politicalSubs;
    }

    function _getAuctionedTracts(params, polyLayer) {
      let d = $q.defer();
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        Query,
        QueryTask
      ) {
        // console.log('made it to the reportdata ', polyLayer);
        let auctionDate = params.date;
        let queryTask = new QueryTask(appConfig.getConfig().tractsHistoryUrl);
        // console.log(appConfig.getConfig().tractsHistoryUrl);
        let query = new Query();
        // query.where = 'Last_LS_date >= \'' + auctionDate + '\'';
        query.where = 'Last_LS_date >= date \'' + _formatStartQueryDate(auctionDate) + '\' AND Last_LS_date <= date \'' + _formatEndQueryDate(auctionDate) + '\'';
        console.log('query where: ', query.where);
        query.returnGeometry = false;
        query.outFields = ['*'];
        queryTask.execute(query, function(results) {
         console.log('results from Tracts History', results.features);
          let features = results.features;
          d.resolve(features);
        }, function(error) {
          d.resolve(error);
          console.error('Query error: ', error);
        });
      });
      return d.promise;
    }

    function _getUnsoldTracts(params) {
      let d = $q.defer();
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        Query,
        QueryTask
      ) {
        // console.log('made it to the reportdata ', polyLayer);
        let auctionDate = params.date;
        let queryTask = new QueryTask(appConfig.getConfig().tractsUrl);
        // console.log(appConfig.getConfig().tractsHistoryUrl);
        let query = new Query();
        // query.where = 'Last_LS_date >= \'' + auctionDate + '\'';
        query.where = 'Last_LS_date >= date \'' + _formatStartQueryDate(auctionDate) + '\' AND Last_LS_date <= date \'' + _formatEndQueryDate(auctionDate) + '\'';
        query.returnGeometry = false;
        query.outFields = ['*'];
        queryTask.execute(query, function(results) {
         console.log('results from Tracts table', results.features);
          let features = results.features;
          d.resolve(features);
        }, function(error) {
          d.resolve(error);
          console.error('Query error: ', error);
        });
      });
      return d.promise;
    }

    function _formatStartQueryDate(date) {
      let newDate = new Date(date);
      return newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate();
    }

    function _formatEndQueryDate(date) {
      let newDate = new Date(date);
      return newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate() + ' 23:59:59';
    }

    function _getPreAuctionTracts(params) {
      let d = $q.defer();
      let auctionDate = params.date;
      // let auctionParcelIDs = [];
      // for (let i = 0; i < results.length; i++) {
      //   auctionParcelIDs.push(results[i].attributes.relGUID);
      // }
      // // console.log(auctionParcelIDs);
      // auctionParcelIDs = auctionParcelIDs.join("','");

      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        Query,
        QueryTask
      ) {
        // console.log('made it to the reportdata ', polyLayer);
        let queryTask = new QueryTask(appConfig.getConfig().tractsUrl);
        let query = new Query();
      //  query.where = 'GlobalID IN (\'' + auctionParcelIDs + '\')';
        query.where = 'Last_LS_date >= date \'' + _formatStartQueryDate(auctionDate) + '\' AND Last_LS_date <= date \'' + _formatEndQueryDate(auctionDate) + '\' AND ProposedSaleType = \'Auction\'';

        query.returnGeometry = false;
        query.outFields = ['*'];
        queryTask.execute(query, function(results) {
          let tracts = results.features;
          d.resolve(tracts);
        }, function(error) {
          console.error('Query error: ', error);
        });
      });
      return d.promise;
    }

    function _processPostAuctionResults(historyTracts, salesYTD, unsoldTracts) { //saleTableResults,
      let reportData = {
        auctionAcres: {
          acres_lessThan2: 0,
          acres_2to5: 0,
          acres_5to10: 0,
          acres_10to20: 0,
          acres_20orMore: 0
        },
        onContract: 0,
        cash: 0,
        totalValue: 0,
        totalRevenue: 0,
        overApprValue: 0,
      //  parcelsOffered: 0,
      //  parcelsSold: 0,
        tractsOffered: 0,
        tractsSold: 0,
        ytdAcres: {
          acres_lessThan2: 0,
          acres_2to5: 0,
          acres_5to10: 0,
          acres_10to20: 0,
          acres_20orMore: 0
        },
      //  ytdDirect: 0,
        ytdOTC: 0,
        ytdAuction: 0,
        ytdContract: 0,
        ytdTotalValue: 0
      };

      for (let i = 0; i < salesYTD.length; i++) {
        // let purchaseDate = new Date(salesYTD[i].attributes.PurchaseDate)
        // console.log('PurchaseDate', purchaseDate);
        _assignParcelSizes(salesYTD[i], reportData.ytdAcres);
        // if (salesYTD[i].attributes.Sold_type === 'Direct Sale') {
        //   reportData.ytdDirect++;
        // }
        if (salesYTD[i].attributes.Sold_type === 'Over the Counter') {
          reportData.ytdOTC++;
        } else if (salesYTD[i].attributes.Sold_type === 'Auction') {
          reportData.ytdAuction++;
        }
        if (salesYTD[i].attributes.TaxForfeitedStatus === 'Active Contract') {
          reportData.ytdContract++;
        }

        // original year to date calculation
        // reportData.ytdTotalValue += salesYTD[i].attributes.Land_price + salesYTD[i].attributes.Imp_price;
        // updated calculation based on Heather's feedback from 12/6/19
        reportData.ytdTotalValue += (salesYTD[i].attributes.Start_bid_price - salesYTD[i].attributes.Special_price);
      }

      for (let i = 0; i < historyTracts.length; i++) {
         reportData.tractsOffered++;
        //  console.log(historyTracts[i]);
        // if parcels sold
        // TODO: get parcels where PurchaseDate = selected auction date-- the database doesn't have any actual dates in that field now
        if (historyTracts[i].attributes.Sold_type === 'Auction') {
          reportData.tractsSold++;
          reportData.totalRevenue += historyTracts[i].attributes.Purch_price;
          reportData.totalValue += historyTracts[i].attributes.Land_price + historyTracts[i].attributes.Imp_price;

          _assignParcelSizes(historyTracts[i], reportData.auctionAcres);

          // get number sold on contract
          if (historyTracts[i].attributes.TaxForfeitedStatus === 'Active Contract') {
            reportData.onContract++;
          }
          if (historyTracts[i].attributes.Purch_price > (historyTracts[i].attributes.Land_price + historyTracts[i].attributes.Imp_price)) {
            reportData.overApprValue++;
          }
          // TODO: Is this an accurate way to get # sold for cash?
          reportData.cash = reportData.tractsSold - reportData.onContract;
        }
      }

      for (let i = 0; i < unsoldTracts.length; i++) {
        reportData.tractsOffered++;
      }

      // let tracts = [],
      //   soldTracts = [];
      // for (let i = 0; i < saleTableResults.length; i++) {
      //   let tractNum = saleTableResults[i].attributes.Tract;
      //   if (tractNum != null) {
      //     // console.log(tractNum);
      //     // get array of distinct tract numbers from Sale Dates table
      //     if (tracts.indexOf(tractNum) < 0) {
      //       tracts.push(tractNum);
      //     }
      //     if (saleTableResults[i].attributes.Sold === saleTableResults[i].attributes.SaleDate && soldTracts.indexOf(tractNum) < 0) {
      //       soldTracts.push(tractNum);
      //     }
      //   }
      // }
      // reportData.tractsOffered = tracts.length;
      // reportData.tractsSold = soldTracts.length;

      return reportData;
    }

    function _processRevalueResults(features, dateRangeOptions) {
      //  console.log(features);
      let politicalSubs = [];
      let politicalSubsDomain = getDomainValues('Political_Sub');
      let useDateRange = dateRangeOptions.dateRange;

      for (let i = 0; i < features.length; i++) {
        // let dateConv = new Date(features[i].attributes.Last_LS_date);
        // features[i].attributes.Last_LS_date = dateConv.toLocaleString();
        // console.log(features[i].attributes.Last_LS_date);
        let landIncDate = _formatEsriDate(features[i].attributes.LandPriceIncrease),
          landDecDate = _formatEsriDate(features[i].attributes.ReducedLandPrice),
          specialIncDate = _formatEsriDate(features[i].attributes.SpecAssessIncrease),
          specialDecDate = _formatEsriDate(features[i].attributes.SpecAssessDecrease),
          lastAuctionDate = _formatEsriDate(features[i].attributes.Last_LS_date),
          startDate = _formatEsriDate(dateRangeOptions.startDate),
          endDate = _formatEsriDate(dateRangeOptions.endDate);

        let landPriceIncrease = 0,
          landPriceDecrease = 0,
          specPriceIncrease = 0,
          specPriceDecrease = 0;

        // If a date range is used, only look for dates between the start and end

        // if the evaluation field is not null, evaluate the dates (conversion function turns nulls to default dates)
        if (features[i].attributes.LandPriceIncrease) {
          // If a date range isn't use, evaluate the dates against the last_ls_date, otherwise only count dates between given start/end
          if (!useDateRange) {
            if (landIncDate < lastAuctionDate) {
              landPriceIncrease = 1;
            }
          } else {
            if (landIncDate >= startDate && landIncDate <= endDate) {
              landPriceIncrease = 1;
            }
          }
        }

        if (features[i].attributes.ReducedLandPrice) {
          // If a date range isn't use, evaluate the dates against the last_ls_date, otherwise only count dates between given start/end
          if (!useDateRange) {
            if (landDecDate < lastAuctionDate) {
              landPriceDecrease = 1;
            }
          } else {
              if (landDecDate >= startDate && landDecDate <= endDate) {
                landPriceDecrease = 1;
              }
            }
        }
        
        if (features[i].attributes.SpecAssessIncrease) {
          if (!useDateRange) {
            if (specialIncDate < lastAuctionDate) {
              specPriceIncrease = 1;
            }
          } else {
            if (specialIncDate >= startDate && specialIncDate <= endDate) {
              specPriceIncrease = 1;
            }
          }
        }
        
        if (features[i].attributes.SpecAssessDecrease) {
          if (!useDateRange) {
            if (specialDecDate < lastAuctionDate) {
              specPriceDecrease = 1;
            }
          } else {
            if (specialDecDate >= startDate && specialDecDate <= endDate) {
              specPriceDecrease = 1;
            }
          }
        }
        
        let featurePolSub = _.find(politicalSubsDomain, {
          'code': features[i].attributes.Political_Sub
        });
        let thePolSub = _.find(politicalSubs, {
          'polSubName': featurePolSub.name
        });
        if (thePolSub == null) {
          let polSubReport = {
            'polSubName': featurePolSub.name,
            'landIncrease': landPriceIncrease,
            'landDecrease': landPriceDecrease,
            'specialIncrease': specPriceIncrease,
            'specialDecrease': specPriceDecrease,
            'total': landPriceIncrease + landPriceDecrease + specPriceDecrease + specPriceIncrease
          };
          politicalSubs.push(polSubReport);
        } else {
          thePolSub.landIncrease += landPriceIncrease;
          thePolSub.landDecrease += landPriceDecrease;
          thePolSub.specialIncrease += specPriceIncrease;
          thePolSub.specialDecrease += specPriceDecrease;
          thePolSub.total += landPriceIncrease + landPriceDecrease + specPriceDecrease + specPriceIncrease;
        }
      }
      return politicalSubs;
    }

    function _processFinalSaleListResults(features) {
      let politicalSubs = [];
      let politicalSubsDomain = getDomainValues('Political_Sub');
      for (let i = 0; i < features.length; i++) {
        let featurePolSub = _.find(politicalSubsDomain, {
          'code': features[i].attributes.Political_Sub
        });
        let thePolSub = _.find(politicalSubs, {
          'polSubName': featurePolSub.name
        });
        if (thePolSub == null) {
          let polSubReport = {
            'polSubName': featurePolSub.name,
            'tracts': [features[i].attributes]
          };
          politicalSubs.push(polSubReport);
        } else {
          thePolSub.tracts.push(features[i].attributes);
        }
      }
      //    console.log(politicalSubs);
      return politicalSubs;
    }

    function _processForfeitValueChangeResults(features) {
      let lots = [];
      for (let i = 0; i < features.length; i++) {
        let lot = {};
        lot['pin'] = features[i].attributes.PIN;
        lot['physCity'] = features[i].attributes.Political_Sub;
        lot['twp'] = features[i].attributes.Twp;
        lot['section'] = features[i].attributes.Sec;
        lot['range'] = features[i].attributes.Rnge;
        lot['tract'] = features[i].attributes.Tract;
        lot['legacyPin'] = features[i].attributes.Legacy_PIN;
        lots.push(lot);
      }
      //    console.log(politicalSubs);
      return lots;
    }

    function _getYTDdata(params) {
      let d = $q.defer();
      esriLoader.require([
        'esri/tasks/query',
        'esri/tasks/QueryTask'
      ], function(
        Query,
        QueryTask
      ) {
        // console.log('made it to the reportdata ', polyLayer);
        let auctionDate = params.date;
        // console.log(auctionDate);
        let auctionYearStart = '1/01/' + new Date(auctionDate).getFullYear();
        let queryTask = new QueryTask(appConfig.getConfig().tractsHistoryUrl);
        let query = new Query();
        query.where = 'PurchaseDate >= date \'' + _formatStartQueryDate(auctionYearStart) + '\' AND PurchaseDate <= date \'' + _formatEndQueryDate(auctionDate) + '\'';
        // console.log('YTD query', query.where);
        // query for testing
        // query.where = 'PurchaseDate IS NULL';
        query.returnGeometry = false;
        query.outFields = ['*'];
        queryTask.execute(query, function(results) {
          let salesYTD = results.features;
          console.log('salesYTD', salesYTD);
          d.resolve(salesYTD);
        }, function(error) {
          console.error('Query error: ', error);
        });
      });
      return d.promise;
    }

    function _processUnsoldParcelsResults(features) {
      let politicalSubs = [];
      let politicalSubsDomain = getDomainValues('Political_Sub');
      for (let i = 0; i < features.length; i++) {
        let featurePolSub = _.find(politicalSubsDomain, {
          'code': features[i].attributes.Political_Sub
        });
        let thePolSub = _.find(politicalSubs, {
          'polSubName': featurePolSub.name
        });
        let acres = {
          _lessThan2: 0,
          _2to5: 0,
          _5to10: 0,
          _10to20: 0,
          _20orMore: 0
        };
        let riparian = 0;
        if (features[i].attributes.LakeNumber != null && features[i].attributes.LakeNumber !== 0) {
          riparian = 1;
        }
        if (features[i].attributes.Acres == null) {
          console.log('hey, null acre value: ', features[i].attributes.Acres);
        } else if (features[i].attributes.Acres < 2) {
          acres._lessThan2 = 1;
        } else if (features[i].attributes.Acres >= 2 && features[i].attributes.Acres < 5) {
          acres._2to5 = 1;
        } else if (features[i].attributes.Acres >= 5 && features[i].attributes.Acres < 10) {
          acres._5to10 = 1;
        } else if (features[i].attributes.Acres >= 10 && features[i].attributes.Acres < 20) {
          acres._10to20 = 1;
        } else if (features[i].attributes.Acres >= 20) {
          acres._20orMore = 1;
        }

        if (thePolSub == null) {
          let polSubReport = {
            'polSubName': featurePolSub.name,
            'parcelCount': 1,
            'totalParcelValue': features[i].attributes.Land_price + features[i].attributes.Imp_price,
            'assessments': features[i].attributes.Special_price,
            'acres_lessThan2': acres._lessThan2,
            'acres_2to5': acres._2to5,
            'acres_5to10': acres._5to10,
            'acres_10to20': acres._10to20,
            'acres_20orMore': acres._20orMore,
            'riparian': riparian
          };
          politicalSubs.push(polSubReport);
        } else {
          thePolSub.parcelCount++;
          thePolSub.totalParcelValue += features[i].attributes.Land_price + features[i].attributes.Imp_price;
          thePolSub.assessments += features[i].attributes.Special_price;
          thePolSub.acres_lessThan2 += acres._lessThan2;
          thePolSub.acres_2to5 += acres._2to5;
          thePolSub.acres_5to10 += acres._5to10;
          thePolSub.acres_10to20 += acres._10to20;
          thePolSub.acres_20orMore += acres._20orMore;
          thePolSub.riparian += riparian;
        }
      }

      return politicalSubs;
    }

    function _formatEsriDate(date) {
      let newDate = new Date(date);
      date = new Date(newDate.getTime() + newDate.getTimezoneOffset() * 60000);
      return date;
    }

    function _assignParcelSizes(parcel, acresObject) {
      let acreage = parcel.attributes.Acres;
      if (acreage == null) {
        console.log('hey, null acre value: ', acreage);
      } else if (acreage < 2) {
        acresObject.acres_lessThan2++;
      } else if (acreage >= 2 && acreage < 5) {
        acresObject.acres_2to5++;
      } else if (acreage >= 5 && acreage < 10) {
        acresObject.acres_5to10++;
      } else if (acreage >= 10 && acreage < 20) {
        acresObject.acres_10to20++;
      } else if (acreage >= 20) {
        acresObject.acres_20orMore++;
      }
    }

    function getDomainValues(field) {
      console.log('field: ', field);
      return _.find(fields, {
        'name': field
      }).domain.codedValues;
    }

    // function _allPromises(features) {
    //   let promises = [];
    //   for (let i = 0; i < features.length; i++) {
    //     // query each property to get the images from the attachments
    //     promises.push(PreviewPanel.queryAttachments(features[i].attributes.OBJECTID, filterLayerPoly));
    //   }
    //   return $q.all(promises);
    // }
  }
